// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3un5A","question":"styles_question__3tI5j","description":"styles_description__3Cx9p"};